var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"areaMap"},[_c('div',{staticClass:"all-institutions"},[_c('secondaryMap',{ref:"secondaryMap",attrs:{"region":_vm.pathData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }